import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentType } from './model/attachmentType';

@Component({
    selector: 'app-assessment-report-application',
    templateUrl: './assessmentReport.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssessmentReportApplicationComponent implements OnInit {
    @Input() application: any;
    attachmentType = AttachmentType;
    grade!: number;
    name!: string;
    submittedAt: any;
    progressReport: any;
    countersignerComment: any;
    confirmedTempRegistration!: boolean;
    constructor() { }

    ngOnInit() {
        this.grade = this.application.grade;
        this.name = this.application.name;
        this.submittedAt = this.application.submittedDate;
        this.progressReport = this.application.progressReport;
        this.confirmedTempRegistration = this.application.confirmedTempRegistration;
        this.countersignerComment = this.progressReport.countersignerComment;
    }

}

